import React, { useEffect, useState } from 'react';
import { Justify } from 'tea-component';
import PostCard from '../PostCard';
import Choose from '../../Choose';
import { postSelectOptions } from '../../../constants';
import { getFeedsComments } from '@/pages/opinion/services/feeds';
import { arrayToObj, uniqueArray } from '@/pages/opinion/utils';
import { getPostUserInfo } from '@/pages/opinion/services/accounts';
import SvgIcon from '@/pages/home/components/SvgIcon';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { goStatsDetailAction } from '@/pages/opinion/pages/stats/Detail';
import { useHistory } from 'umi';

export function Comments({
  keepParams,
  channel,
  dataReBackNotice,
  itemClick,
  languageType,
  gameInfo,
  wholeGameInfo,
}: any) {
  const [posts, setPosts] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [postsLoading, setPostsLoading] = useState(false);
  const [postsError, setPostsError] = useState(false);
  const [by, setBy] = useState('engagement');

  useEffect(() => {
    if (!keepParams.edition_unified_id) return;
    setPostsLoading(true);
    getFeedsComments({
      ...keepParams,
      page: 1,
      page_size: 3,
      sort_item: by,
      sort_model: 'desc',
    }).then((data: any) => {
      let { list, total } = data || {};
      setTotal(total || 0);
      list = list || [];
      dataReBackNotice?.({ post: list.length === 0 });
      if (list.length > 0) {
        let users = list.map((item: any) => item.anchor_md5).filter(Boolean);
        users = uniqueArray(users);
        getUserInfo(users);
      }
      setPosts(list);
      setPostsError(false);
      setPostsLoading(false);
    });
  }, [keepParams, by]);

  const [iconLoading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const getUserInfo = (userIds: Array<string>) => {
    if (userIds.length > 0) {
      setLoading(true);
      getPostUserInfo({ anchor_md5s: userIds }).then((data: any) => {
        const { list } = data || { list: [] };
        setUserInfo(arrayToObj(list, 'anchor_md5'));
        setLoading(false);
      });
    }
  };
  const history = useHistory();
  const jumpToFeeds = () => {
    // 获取本地的筛选器
    // 通转feeds页面，暂时不跳
    // return;
    goStatsDetailAction({
      path: `/opinion/Feeds/Feeds${
        gameInfo?.edition_unified_id
          ? `?gameid=${gameInfo?.edition_unified_id}&tab=socialMedia`
          : '?tab=socialMedia'
      }`,
      params: {
        statsDetailType: 'feeds-Influencer',
        ...keepParams,
        channel: keepParams.channel.map((item: string) => 'social@' + item),
      },
      history,
    });
  };

  const { formatMessage, formatOptionsMessage } = useLanguage();

  return (
    <div className="dbo-accountsbox-posts">
      <Justify
        className="dbo-accountsbox-posts-justify"
        left={
          <Choose
            selects={formatOptionsMessage(postSelectOptions)}
            prefix={formatMessage({ id: 'Top Posts by' })}
            onChange={(choose) => setBy(choose)}
          ></Choose>
        }
        right={
          total > 3 ? (
            <div onClick={jumpToFeeds} className="dbo-accountsbox-posts-more">
              <span>{formatMessage({ id: 'More Posts' })}</span>
              <SvgIcon type="arrow-right" />
            </div>
          ) : null
        }
      />
      <div className="dbo-accountsbox-postsbox">
        {posts && posts.length > 0 ? (
          posts.map((item) => (
            <PostCard
              key={item.anchor_md5 + item.comment_uin}
              itemClick={itemClick}
              iconLoading={iconLoading}
              userInfo={userInfo[item.anchor_md5]}
              info={item}
              channel={channel}
              languageType={languageType}
              wholeGameInfo={wholeGameInfo}
            ></PostCard>
          ))
        ) : (
          <span className="dbo-accounts-nodata" style={{ minHeight: 300 }}>
            {formatMessage({ id: 'No data' })}
          </span>
        )}
      </div>
    </div>
  );
}
